/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhoneBelongsToLevelSheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-BELONGS-LEVEL-001
 * PURPOSE: Phone sheet for the same Belongs to Level box as desktop.
 */
import { useEffect, useState } from 'react'
import { MobileSheet } from '@quotech/ui'
import type { QaAreaExecution, QaFloor } from '../../../../qa/qaApi'
import { normalizeList } from '../../../../qa/qaApiHelpers'
import { QaBelongsToLevelBox } from '../../QaBelongsToLevelBox'
import type { JobQaTabController } from '../../useJobQaTabController'

export function QaPhoneBelongsToLevelSheet({
  open,
  onClose,
  controller,
}: {
  open: boolean
  onClose: () => void
  controller: JobQaTabController
}) {
  const areas = normalizeList<QaAreaExecution>(controller.workspace.areasQuery.data)
  const floors = normalizeList<QaFloor>(controller.workspace.floorsQuery.data)
  const [otherLevels, setOtherLevels] = useState<string[]>([])
  useEffect(() => {
    if (!open) return
    void controller.api.listGroupNames(controller.props.jobId).then(setOtherLevels).catch(() => setOtherLevels([]))
  }, [controller.api, controller.props.jobId, open])
  return (
    <MobileSheet open={open} onClose={onClose} title="Belongs to Level:">
      <QaBelongsToLevelBox
        floors={floors}
        areas={areas}
        otherLevelNames={otherLevels}
        busy={controller.tree.move.isPending}
        onCancel={onClose}
        onSubmit={(destination) => {
          const nodeIds = controller.selection.visibleOf('areas', areas.map((area) => area.id))
          // Reused from: packages/job-hub/src/jobs/tabs/job-qa/useQaTreeMoves.ts (tree.move)
          controller.tree.move.mutate(
            { nodeType: 'area', nodeIds, destination },
            { onSuccess: () => { onClose(); controller.selection.clear() } },
          )
        }}
      />
    </MobileSheet>
  )
}
